import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TempUser } from 'src/app/models/tempuser.model';
import { User } from 'src/app/models/user.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  baseUrl: string = environment.apiUrl

  constructor(private http: HttpClient) { }

  retrieveUsers(userRequest: any): Observable<User[]> {
    const searchParam = encodeURIComponent(String(userRequest.search || '').trim());
    return this.http.get<User[]>(this.baseUrl + `/userGroup/user/plant/${userRequest.pageNumber}/${userRequest.pageSize}?searchParam=${searchParam}&plantId=${userRequest.plantId || ''}`)
  }

  retrieveTempUsers(userRequest: any): Observable<TempUser[]> {
    const searchParam = encodeURIComponent(String(userRequest.search || '').trim());
    return this.http.get<TempUser[]>(this.baseUrl + `/TempUserGroup/user/plant/${userRequest.pageNumber}/${userRequest.pageSize}?searchParam=${searchParam}&plantId=${userRequest.plantId || ''}`)
  }

}
